import { render, staticRenderFns } from "./DoorImpacts.vue?vue&type=template&id=72a7e8f8&scoped=true"
import script from "./DoorImpacts.vue?vue&type=script&lang=ts"
export * from "./DoorImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a7e8f8",
  null
  
)

export default component.exports